export default __webpack_public_path__ + "static/Group-1260-3dcec00c2fb7f7cdf6157c6381354e99.png";